<template>
  <div>
    <v-row class="ma-0 form-item-heading" :class="headingBgColor">
      <v-subheader class="text-subtitle-1 align-center" :class="[headingTextColor ? `${headingTextColor}--text` : null, headingPadding, {'font-weight-bold': $vuetify.breakpoint.mdAndUp}]">
        <span style="color: #2c2c2c">{{ isValueBooks ? '査定の明細' : '買取の明細' }}</span>
      </v-subheader>
    </v-row>

    <v-row v-if="data != null" class="ma-0 mt-1 mb-1">
      <v-col>
        <v-data-table
          :headers="assessItemsHeaders"
          :items="data.assessItems"
          :items-per-page="10"
          :footer-props="{itemsPerPageText: '表示件数'}"
          class="elevation-1 mb-2"
          :header-props="{sortByText: '並び替え'}"
        >
          <template v-slot:item.condition="{ item }">
            {{ getCondition(item.assessedPrice, item.condition, '買取不可') }}
          </template>
          <template v-slot:item.assessedPrice="{ item }">
            {{ item.assessedPrice | addCommaSeparator }}円
          </template>
        </v-data-table>
        <ul class="mt-5 text-caption">
          <li>
            ※状態については「良い：キズや使用感はあるが概ね良好な状態」、「可：傷み、汚れ、欠品などがある状態」を示しています。
          </li>
          <li>
            ※お送り頂いた商品が以下のような場合、明細に表示することができないことがあります。
            <ul class="pl-0 pl-md-3" style="font-size:10px;line-height:1rem;">
              <li>・査定時に不可と判断した商品（状態が悪い、弊社商品データベースに存在しない等）</li>
              <li>・査定対象外の商品（ISBNがない商品等）</li>
            </ul>
          </li>
        </ul>

      </v-col>
      <v-col cols="auto" class="mx-auto">
        <section class="receipt">
          <div class="contents">
            <ul class="pa-3" style="border-top:solid 8px #fbfaf5;">
              <p>内訳</p>
              <v-divider style="border-color:#2c2c2c;" />
              <li>
                <p>総数</p>
                <p>{{ data.totalCount | addCommaSeparator }} 点</p>
              </li>
              <li>
                <p>買い取れた商品</p>
                <p>{{ data.okCount | addCommaSeparator }} 点</p>
              </li>
              <li>
                <p>買い取れなかった商品</p>
                <p>{{ data.ngCount | addCommaSeparator }} 点</p>
              </li>

              <li>
                <p class="label torihikikingaku-goukei-label">査定金額</p>
                <p class="torihikikingaku-goukei-body">{{ data.itemsTotalAmount | addCommaSeparator }} 円</p>
              </li>
            </ul>
            <ul class="pa-3" style="border-top:solid 8px #fbfaf5;">
              <li v-if="data.campaignInfo && data.campaignInfo.isKasanRitsu" class="campaign-zouritsu">
                <p class="ma-0">クーポン</p>
                <p class="ma-0">
                  (査定金額に対して)
                  +{{ data.campaignInfo.kasanRitsu }} %
                </p>
              </li>
              <li v-if="data.campaignInfo && data.campaignInfo.isKasanRitsu" class="campaign-zouritsu__comment">
                ※キャンペーンが重複した場合、最も買取率が高いものが適用されます。
              </li>

              <li v-if="data.campaignInfo && data.campaignInfo.isKasanGaku" class="campaign-zougaku">
                  <p class="ma-0">クーポン</p>
                  <p class="ma-0">+{{ data.campaignInfo.kasanGaku | addCommaSeparator }} 円</p>
              </li>
            </ul>

            <ul class="pa-3" style="border-top:solid 8px #fbfaf5;">
              <li v-if="data.campaignInfo && data.campaignInfo.isShippingFree" class="souryou__free">
                <p class="label souryou-label ma-0">送料</p>
                <p class="souryou-body ma-0">0 円</p>
              </li>
              <li v-if="data.campaignInfo && data.campaignInfo.isShippingFree" class="souryou__free__message">
                <p >送料無料クーポンが適用されます</p>
              </li>
              <li v-else class="souryou">
                <p class="label souryou-label ma-0">送料（{{ data.boxCount }} 箱）</p>
                <p class="souryou-body ma-0">{{ data.totalShipping | addCommaSeparator }} 円</p>
              </li>
              <li>
                <p class="label torihikikingaku-goukei-label">小計</p>
                <p class="torihikikingaku-goukei-body">{{ data.totalAmount | addCommaSeparator }} 円</p>
              </li>
            </ul>

            <v-list v-if="data.campaignInfo && data.campaignInfo.isKCampaign"
              class="pa-3"
              style="border-top:solid 8px #fbfaf5;"
            >
              <v-list v-if="data.campaignInfo.isSokuhuri" class="campaign-zougaku">
                <p class="ma-0">ソクフリ選択による増額</p>
                <p class="ma-0">+{{ data.campaignInfo.kasanGakuSokuhuri | addCommaSeparator }} 円</p>
              </v-list>
              <v-list v-if="data.campaignInfo.isMailSend" class="campaign-zougaku">
                <p class="ma-0">メール購読による増額</p>
                <p class="ma-0">+{{ data.campaignInfo.kasanGakuMailSend | addCommaSeparator }} 円</p>
              </v-list>
            </v-list>

            <v-card flat class="d-flex justify-space-between pa-3"
              style="border-top:solid 8px #fbfaf5;"
            >
              <p class="label ginkoufurikomi-label font-weight-bold mb-0">買取金額 合計<br /><span class="text-body-2">(振込金額)</span></p>
              <p class="ginkoufurikomi-body font-weight-bold mb-0">{{ data.totalAmount | addCommaSeparator }}円</p>
            </v-card>

            <v-card flat class="d-flex justify-space-between pa-3"
              style="border-top:solid 8px #fbfaf5;"
            >
              <p class="mb-0">獲得ポイント</p>
              <p class="mb-0">{{ data.points | addCommaSeparator }}</p>
            </v-card>

            <v-list v-if="data.campaignInfo && data.campaignInfo.isKCampaign"
              class="pa-3"
              style="border-top:solid 8px #fbfaf5;"
            >
              <p class="font-weight-bold mb-0">エントリーしているキャンペーン</p>
              <v-list-item v-for="(item,index) in data.campaignInfo.CampaignName" 
                :key="index"
                class="red--text text--darken-2"
              >
                ・{{ item }}
              </v-list-item>
              <p class="text-caption grey--text text--draken-2">※キャンペーンの適用は査定金額に対して行います</p>
            </v-list>

          </div>
          <!-- メインサイトの場合のみ表示 -->
          <template v-if="isValueBooks">
            <v-radio-group
              v-model="executableRadio"
              class="px-2"
            >
              <v-radio
                v-if="isBuyPriceGreaterZero"
                :value="1"
                key="1"
                class="mb-5"
                color="#0095d9"
              >
                <template v-slot:label>
                  <v-row dense no-gutters class="mt-0">
                    <v-col cols="6" class="pt-0 grey--text text--darken-4">銀行振込</v-col>
                    <v-col cols="6" class="pt-0 text-right grey--text text--darken-4">{{ stateItems.gTotalInput | addCommaSeparator }} 円</v-col>
                  </v-row>
                </template>
              </v-radio>
              <v-radio
                v-else
                :value="1"
                key="1"
                class="mb-5"
                color="#0095d9"
              >
                <template v-slot:label>
                  <v-row dense no-gutters class="mt-0">
                    <v-col cols="12" class="pt-0 grey--text text--darken-4">弊社での引受</v-col>
                  </v-row>
                </template>
              </v-radio>
              <v-radio
                :value="2"
                key="2"
                class="mb-5"
              >
                <template v-slot:label>
                  <v-row dense no-gutters class="mt-0">
                    <v-col cols="6" class="pt-0 grey--text text--darken-4">キャンセルして返送</v-col>
                    <v-col cols="6" class="pt-0 text-right grey--text text--darken-4">0 円</v-col>
                  </v-row>
                </template>
              </v-radio>
            </v-radio-group>
            <v-btn
              @click="executableRadioModal"
              color="#0095d9"
              class="white--text"
              width="100%"
              tile
              elevation="0"
              height="50"
            >
              確定する
            </v-btn>
          </template>
        </section>
      </v-col>
    </v-row>
    <v-card v-else flat>
      <v-divider class="mt-0" />
      <v-card-title class="text-body-1">{{ isValueBooks ? '査定の明細' : '買取の明細' }}データがありません。</v-card-title>
    </v-card>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: "assess-items",
  components: {},
  inject: [
    'stateItems',
    'isBuyPriceGreaterZero',
    'isValueBooks',
    'executableRadioModal',
  ],
  props: {
    headingBgColor: {type: String, default: null},
    headingTextColor: {type: String, default: null},
    headingPadding: {type: String, default: null},
    data: {type: Object, default: null},
  },
  data: function () {
    return {
      assessItemsHeaders: [
        {
          text: 'タイトル',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        { text: '状態', value: 'condition' },
        { text: '査定価格', value: 'assessedPrice' },
      ],
    }
  },
  methods: {
    ...mapMutations('buyState', ['setAssessmentResultAnswerValue']),
    getCondition(price, condition, conditionFallbackTo) {
      if (price === 0) {
        return conditionFallbackTo;
      }
      return condition;
    }
  },
  computed: {
    executableRadio: {
      get() {
        return this.stateItems.assessmentResultAnswerValue
      },
      set(value) {
        this.setAssessmentResultAnswerValue(value);
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .v-text-field input[readonly] {
    background-color: unset;
    color: unset;
    border: 0 none;
  }
}
.row {
  margin-top: 0;
  margin-bottom: 0;
}
.specify-border {
    position: relative;
    &:after {
        content: "";
        display: block;
        border-top: 1px solid #FBFAF5;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }
}
.popularity-rating-star img {
  height: 14px;
  width: 15px;
  margin-left: 3px;
  margin-top: 5px;
  vertical-align: top;
}

// resources\sass\modules\pc\_kaitori_history.scssよりコピー
.receipt {
  width: 300px;
  box-sizing: border-box;
  padding: 15px;
  background-color: $gray_color;
  .contents {
      background-color: #FFF;
      font-size: 16px;

      ul {
          border-top: solid 1px #000;
          padding: 32px 0;
          li {
              //@include display-flex();
              display: flex;
              //@include justify-content(space-between);
              justify-content: space-between;
              //@include align-items(baseline);
              align-items: baseline;
              margin-bottom: 8px;
              &:last-child {
                  margin-bottom: 0;
              }
              .label {
                  font-weight: 800;
              }
              .souryou-label,
              .souryou-body {
                  font-weight: bold;
              }
              .torihikikingaku-goukei-label,
              .torihikikingaku-goukei-body,
              .points {
                  font-weight: 800;
              }
              .ginkoufurikomi-label,
              .ginkoufurikomi-body {
                  font-weight: 800;
              }
              .ginkoufurikomi-body {
                  font-size: 20px;
              }
          }
          .souryou {
              padding-top: 8px;
              margin-bottom: 16px;
          }
          .souryou__free {
              padding-top: 8px;
              margin-bottom: 0;
              &__message{
                  display: flex;
                  justify-content: flex-start;
                  margin-bottom: 16px;
                  p{
                      color: $blue_color;
                      font-size: 12px;
                  }
              }
          }
          .campaign-zouritsu{
              color: $blue_color;
              display: flex;
              justify-content: space-between;
              margin-bottom: 2px;
              font-size: 14px;
              p{
                  font-weight: bold;
              }
              &__comment{
                  font-size: 12px;
                  color: #898989;
              }
          }
          .campaign-name {
              margin-bottom: 4px;
          }
      }
      .campaign-zougaku{
        color: $blue_color;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        p{
          font-weight: bold;
        }
      }

      .btn-delete {
          padding: 8px;
          font-size: 12px;
      }
  }
}
</style>